// Detailed property profiles. Currently populated for "the-bay" using public records
// (propsearch.ae / Dubai Land Department open data).
export const propertyDetails = {
  "the-bay": {
    en: {
      name: "The Bay",
      location: "Business Bay, Dubai",
      tagline: "A 20-storey residence on the Business Bay canal.",
      description:
        "The Bay is a 20-storey residential tower on the Business Bay canal in Dubai. Completed in December 2021, the building combines a sculpted glass façade with a quiet, hospitality-grade ground floor of services. Two basement levels provide secure resident parking and select retail.",
      images: [
        "https://static.propsearch.ae/dubai-locations/the-bay_oiDVF_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/the-bay_kzD2Z_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/the-bay_Y50Tk_xl.jpg",
      ],
      specs: [
        { label: "Type", value: "Residential high-rise" },
        { label: "Storeys", value: "20 floors + 2 basement levels" },
        { label: "Status", value: "Complete · Dec 2021" },
        { label: "Construction", value: "Started 2019" },
        { label: "Architect", value: "Art Consultants Dubai" },
        { label: "Main contractor", value: "Gulf Asia Contracting" },
        { label: "Foundation", value: "Edrafor Piling & Special Foundation" },
        { label: "Area", value: "Business Bay" },
        { label: "Master project", value: "Business Bay" },
      ],
      units: [
        { type: "1-bedroom apartments", size: "≈ 780 – 860 sq ft", parking: "Included" },
        { type: "2-bedroom apartments", size: "≈ 1,130 – 1,360 sq ft", parking: "Included" },
      ],
      amenities: [
        "Two basement parking levels",
        "On-site mini-mart & bakery",
        "Pharmacy & medical clinic",
        "Men's barber & ladies' salons",
        "Restaurant & laundrette",
        "Flower shop",
        "Canal-side promenade access",
        "24-hour building security",
      ],
      connectivity: [
        { label: "Dubai Mall", value: "≈ 8 min drive" },
        { label: "Burj Khalifa / Downtown", value: "≈ 8 min drive" },
        { label: "DXB International Airport", value: "≈ 14 min drive" },
        { label: "Palm Jumeirah", value: "≈ 21 min drive" },
        { label: "Bayside Park 7", value: "0.3 km" },
        { label: "The Lana hotel", value: "0.4 km" },
      ],
      source:
        "Reference data: Dubai Land Department open data and propsearch.ae public records.",
    },
    ar: {
      name: "ذا باي",
      location: "الخليج التجاري، دبي",
      tagline: "إقامة من ٢٠ طابقاً على قناة الخليج التجاري.",
      description:
        "ذا باي برج سكني مكوّن من ٢٠ طابقاً يقع على قناة الخليج التجاري في دبي. اكتمل في ديسمبر ٢٠٢١، ويجمع بين واجهة زجاجية منحوتة ومستوى أرضي هادئ من الخدمات بمعايير الضيافة. يوفّر طابقان تحت الأرض مواقف سيارات آمنة للسكان مع منافذ تجارية مختارة.",
      images: [
        "https://static.propsearch.ae/dubai-locations/the-bay_oiDVF_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/the-bay_kzD2Z_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/the-bay_Y50Tk_xl.jpg",
      ],
      specs: [
        { label: "النوع", value: "برج سكني" },
        { label: "الطوابق", value: "٢٠ طابقاً + طابقان تحت الأرض" },
        { label: "الحالة", value: "مكتمل · ديسمبر ٢٠٢١" },
        { label: "البناء", value: "بدأ عام ٢٠١٩" },
        { label: "المعماري", value: "Art Consultants Dubai" },
        { label: "المقاول الرئيسي", value: "Gulf Asia Contracting" },
        { label: "أعمال الأساسات", value: "Edrafor Piling & Special Foundation" },
        { label: "المنطقة", value: "الخليج التجاري" },
        { label: "المشروع الرئيسي", value: "الخليج التجاري" },
      ],
      units: [
        { type: "شقق غرفة نوم واحدة", size: "≈ ٧٨٠ – ٨٦٠ قدم²", parking: "مشمول" },
        { type: "شقق غرفتي نوم", size: "≈ ١,١٣٠ – ١,٣٦٠ قدم²", parking: "مشمول" },
      ],
      amenities: [
        "طابقان للمواقف تحت الأرض",
        "سوبر ماركت ومخبز داخل المبنى",
        "صيدلية وعيادة طبية",
        "صالون رجالي وصالونات نسائية",
        "مطعم ومغسلة ملابس",
        "محل ورد",
        "وصول إلى ممشى القناة",
        "أمن على مدار الساعة",
      ],
      connectivity: [
        { label: "دبي مول", value: "≈ ٨ دقائق بالسيارة" },
        { label: "برج خليفة / وسط دبي", value: "≈ ٨ دقائق بالسيارة" },
        { label: "مطار دبي الدولي", value: "≈ ١٤ دقيقة بالسيارة" },
        { label: "نخلة جميرا", value: "≈ ٢١ دقيقة بالسيارة" },
        { label: "حديقة بايسايد ٧", value: "٠.٣ كم" },
        { label: "فندق ذا لانا", value: "٠.٤ كم" },
      ],
      source:
        "المرجع: بيانات دائرة الأراضي والأملاك في دبي وسجلات propsearch.ae العامة.",
    },
  },

  "battersea-residence": {
    en: {
      name: "Battersea Residence",
      location: "Al Jaddaf, Dubai",
      tagline: "A 14-storey residence in Al Jaddaf — completed July 2020.",
      description:
        "Battersea Residence is a 14-storey residential building in Al Jaddaf, Dubai. Developed by Ali Abdulla Mohammad Alshirawi and designed by Eng. Adnan Saffarini, the building was completed in July 2020 and sits in a well-served residential pocket of Al Jaddaf, minutes from Dubai Creek, Dubai International Airport and the city's arts district.",
      images: [
        "https://static.propsearch.ae/dubai-locations/battersea-residence_ls2bw_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/battersea-residence-23117_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/battersea-residence-22978_xl.jpg",
      ],
      specs: [
        { label: "Type", value: "Residential high-rise" },
        { label: "Storeys", value: "14 floors" },
        { label: "Status", value: "Complete · Jul 2020" },
        { label: "Construction", value: "Started 2017" },
        { label: "Developer", value: "Ali Abdulla Mohammad Alshirawi" },
        { label: "Architect", value: "Eng. Adnan Saffarini" },
        { label: "Main contractor", value: "Gulf Jewel Contracting" },
        { label: "Foundation", value: "Al Zahraa Foundation Contractors" },
        { label: "Area", value: "Al Jaddaf" },
      ],
      units: [
        { type: "Residential apartments", size: "Multiple layouts available", parking: "Allocated" },
        { type: "Ground-floor retail", size: "Supermarket & car-rental on site", parking: "Visitor" },
      ],
      amenities: [
        "On-site supermarket (Super Saver)",
        "On-site car-rental desk (Chance Rent a Car)",
        "Pharmacies, salons & cafés within walking distance",
        "Adjacent to Arabian Park Hotel & Al Jaddaf Rotana Suite",
        "Allocated resident parking",
        "24-hour building security",
        "Cinema (VOX at Grand Hyatt) within 1 km",
      ],
      connectivity: [
        { label: "Dubai International Airport (DXB)", value: "≈ 11 min drive" },
        { label: "Dubai Mall", value: "≈ 12 min drive" },
        { label: "Jameel Arts Centre", value: "1.6 km" },
        { label: "Culture Village Park", value: "1.6 km" },
        { label: "Dubai Creek Golf & Yacht Club", value: "2.8 km" },
        { label: "Dubai Festival City", value: "2.6 km" },
      ],
      source:
        "Reference data: Dubai Land Department open data and propsearch.ae public records.",
    },
    ar: {
      name: "باترسي ريزيدنس",
      location: "الجداف، دبي",
      tagline: "إقامة من ١٤ طابقاً في الجداف — اكتملت في يوليو ٢٠٢٠.",
      description:
        "باترسي ريزيدنس مبنى سكني مكوّن من ١٤ طابقاً في الجداف، دبي. طوّره علي عبدالله محمد الشيراوي وصمّمه المهندس عدنان صفاريني، واكتمل في يوليو ٢٠٢٠. يقع المبنى في حيّ سكني جيد الخدمات في الجداف، على بُعد دقائق من خور دبي ومطار دبي الدولي ومنطقة الفنون.",
      images: [
        "https://static.propsearch.ae/dubai-locations/battersea-residence_ls2bw_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/battersea-residence-23117_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/battersea-residence-22978_xl.jpg",
      ],
      specs: [
        { label: "النوع", value: "مبنى سكني" },
        { label: "الطوابق", value: "١٤ طابقاً" },
        { label: "الحالة", value: "مكتمل · يوليو ٢٠٢٠" },
        { label: "البناء", value: "بدأ عام ٢٠١٧" },
        { label: "المطوّر", value: "علي عبدالله محمد الشيراوي" },
        { label: "المعماري", value: "م. عدنان صفاريني" },
        { label: "المقاول الرئيسي", value: "Gulf Jewel Contracting" },
        { label: "أعمال الأساسات", value: "Al Zahraa Foundation" },
        { label: "المنطقة", value: "الجداف" },
      ],
      units: [
        { type: "شقق سكنية", size: "تصاميم متعددة متاحة", parking: "مخصص" },
        { type: "محلات أرضية", value: "", size: "سوبر ماركت ومكتب تأجير سيارات", parking: "للزوار" },
      ],
      amenities: [
        "سوبر ماركت داخل المبنى (Super Saver)",
        "مكتب تأجير سيارات داخل المبنى (Chance Rent a Car)",
        "صيدليات وصالونات ومقاهٍ على مسافة سير",
        "بجوار فندق Arabian Park وفندق روتانا الجداف",
        "مواقف سيارات مخصصة للسكان",
        "أمن على مدار الساعة",
        "سينما VOX في غراند حياة على بُعد ١ كم",
      ],
      connectivity: [
        { label: "مطار دبي الدولي", value: "≈ ١١ دقيقة بالسيارة" },
        { label: "دبي مول", value: "≈ ١٢ دقيقة بالسيارة" },
        { label: "مركز جميل للفنون", value: "١.٦ كم" },
        { label: "حديقة كلتشر فيليدج", value: "١.٦ كم" },
        { label: "نادي دبي كريك للجولف واليخوت", value: "٢.٨ كم" },
        { label: "دبي فستيفال سيتي", value: "٢.٦ كم" },
      ],
      source:
        "المرجع: بيانات دائرة الأراضي والأملاك في دبي وسجلات propsearch.ae العامة.",
    },
  },

  "spinnaker-residence": {
    en: {
      name: "Spinnaker Residence",
      location: "Al Jaddaf, Dubai",
      tagline: "A 12-storey residence near the Creek, the arts and the city.",
      description:
        "Spinnaker Residence is a 12-storey residential building in Al Jaddaf, Dubai, completed in December 2019. Developed by Ali Abdulla Mohammad Alshirawi and designed by Eng. Adnan Saffarini, the building sits within a quiet, well-connected district minutes from Dubai Creek, the Jameel Arts Centre and Dubai International Airport.",
      images: [
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23137_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23136_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-22972_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23135_xl.jpg",
      ],
      specs: [
        { label: "Type", value: "Residential high-rise" },
        { label: "Storeys", value: "12 floors" },
        { label: "Status", value: "Complete · Dec 2019" },
        { label: "Construction", value: "Started 2017" },
        { label: "Developer", value: "Ali Abdulla Mohammad Alshirawi" },
        { label: "Architect", value: "Eng. Adnan Saffarini" },
        { label: "Main contractors", value: "Gulf Jewel Contracting · Khalifa Al-Fahad Contracting" },
        { label: "Area", value: "Al Jaddaf" },
        { label: "First trace", value: "May 2016" },
      ],
      units: [
        { type: "Residential apartments", size: "Multiple layouts available", parking: "Allocated" },
        { type: "Ground-floor retail", size: "Ladies' salon & spa on site", parking: "Visitor" },
      ],
      amenities: [
        "Ground-floor ladies' salon (Nawaem Al Sham)",
        "On-site spa (Jointss Care Spa)",
        "Walking distance to mini-marts, pharmacies & clinics",
        "Adjacent to Form Hotel Dubai & Pulse Al Jaddaf Hotel",
        "Quiet residential street with low through-traffic",
        "Allocated resident parking",
        "24-hour building security",
      ],
      connectivity: [
        { label: "Dubai International Airport (DXB)", value: "≈ 11 min drive" },
        { label: "Dubai Mall", value: "≈ 13 min drive" },
        { label: "Jameel Arts Centre", value: "1.0 km" },
        { label: "Culture Village Park", value: "1.0 km" },
        { label: "Dubai Creek Golf & Yacht Club", value: "2.4 km" },
        { label: "Dubai Festival City", value: "2.1 km" },
      ],
      source:
        "Reference data: Dubai Land Department open data and propsearch.ae public records.",
    },
    ar: {
      name: "سبينيكر ريزيدنس",
      location: "الجداف، دبي",
      tagline: "إقامة من ١٢ طابقاً قرب الخور ومراكز الفنون والمدينة.",
      description:
        "سبينيكر ريزيدنس مبنى سكني مكوّن من ١٢ طابقاً في الجداف، دبي، اكتمل في ديسمبر ٢٠١٩. طوّره علي عبدالله محمد الشيراوي وصمّمه المهندس عدنان صفاريني. يقع المبنى في حيّ هادئ جيد الاتصال على بُعد دقائق من خور دبي ومركز جميل للفنون ومطار دبي الدولي.",
      images: [
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23137_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23136_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-22972_xl.jpg",
        "https://static.propsearch.ae/dubai-locations/spinnaker-residence-23135_xl.jpg",
      ],
      specs: [
        { label: "النوع", value: "مبنى سكني" },
        { label: "الطوابق", value: "١٢ طابقاً" },
        { label: "الحالة", value: "مكتمل · ديسمبر ٢٠١٩" },
        { label: "البناء", value: "بدأ عام ٢٠١٧" },
        { label: "المطوّر", value: "علي عبدالله محمد الشيراوي" },
        { label: "المعماري", value: "م. عدنان صفاريني" },
        { label: "المقاولون", value: "Gulf Jewel · Khalifa Al-Fahad" },
        { label: "المنطقة", value: "الجداف" },
        { label: "أول رصد", value: "مايو ٢٠١٦" },
      ],
      units: [
        { type: "شقق سكنية", size: "تصاميم متعددة متاحة", parking: "مخصص" },
        { type: "محلات أرضية", size: "صالون نسائي وسبا داخل المبنى", parking: "للزوار" },
      ],
      amenities: [
        "صالون نسائي في الطابق الأرضي (نواعم الشام)",
        "سبا داخل المبنى (Jointss Care Spa)",
        "على مسافة سير من السوبر ماركت والصيدليات والعيادات",
        "بجوار فندق Form Dubai وفندق Pulse Al Jaddaf",
        "شارع سكني هادئ بحركة مرور منخفضة",
        "مواقف سيارات مخصصة للسكان",
        "أمن على مدار الساعة",
      ],
      connectivity: [
        { label: "مطار دبي الدولي", value: "≈ ١١ دقيقة بالسيارة" },
        { label: "دبي مول", value: "≈ ١٣ دقيقة بالسيارة" },
        { label: "مركز جميل للفنون", value: "١.٠ كم" },
        { label: "حديقة كلتشر فيليدج", value: "١.٠ كم" },
        { label: "نادي دبي كريك للجولف واليخوت", value: "٢.٤ كم" },
        { label: "دبي فستيفال سيتي", value: "٢.١ كم" },
      ],
      source:
        "المرجع: بيانات دائرة الأراضي والأملاك في دبي وسجلات propsearch.ae العامة.",
    },
  },
};

export const detailLabels = {
  en: {
    overview: "Overview",
    specs: "Building specifications",
    units: "Residential units",
    amenities: "On-site & in-building amenities",
    connectivity: "Connectivity & landmarks",
    enquire: "Enquire about this building",
    close: "Close",
    no_detail_title: "Details available on request",
    no_detail_body:
      "We share full information on this asset only with serious enquirers. Please contact the office.",
  },
  ar: {
    overview: "نظرة عامة",
    specs: "مواصفات المبنى",
    units: "الوحدات السكنية",
    amenities: "خدمات داخل المبنى",
    connectivity: "الاتصال والمعالم",
    enquire: "استفسر عن هذا المبنى",
    close: "إغلاق",
    no_detail_title: "التفاصيل متاحة عند الطلب",
    no_detail_body:
      "نشارك المعلومات الكاملة عن هذا الأصل مع المستفسرين الجادين فقط. يرجى التواصل مع المكتب.",
  },
};
